import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/module";

export const pagingModule = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getModuleById = (id) => axios.get(API_PATH + "/get-by-id/" + id);

export const saveOrUpdate = module => axios.post(API_PATH + '/save-or-update', module);

export const deleteModule = id => axios.delete(API_PATH + '/mark-delete/' + id);

export const getAllModules = () => axios.get(API_PATH + "/get-all")
